import debounce from 'lodash.debounce';
import { type } from '../util';
import TitleBadgeMixin from '../mixins/titleBadge';
export default {
  mixins: [TitleBadgeMixin],
  data() {
    return {
      postsList: [],
      countByYear: {},
      // 根据年份统计的文章数

      perPage: 80,
      // 每页长
      currentPage: 1 // 当前页
    };
  },
  created() {
    this.getPageData();

    // 根据年份计算出文章数
    const {
      $sortPostsByDate,
      countByYear
    } = this;
    for (let i = 0; i < $sortPostsByDate.length; i++) {
      const {
        frontmatter: {
          date
        }
      } = $sortPostsByDate[i];
      if (date && type(date) === 'string') {
        const year = date.slice(0, 4);
        if (!countByYear[year]) {
          countByYear[year] = 0;
        }
        countByYear[year] = countByYear[year] + 1;
      }
    }
    this.countByYear = countByYear;
  },
  mounted() {
    window.addEventListener('scroll', debounce(() => {
      if (this.postsList.length < this.$sortPostsByDate.length) {
        const docEl = document.documentElement;
        const docBody = document.body;
        const scrollTop = docEl.scrollTop || docBody.scrollTop;
        const clientHeight = docEl.clientHeight || docBody.clientHeight;
        const scrollHeight = docEl.scrollHeight || docBody.scrollHeight;
        if (scrollHeight > clientHeight && scrollTop + clientHeight >= scrollHeight - 250) {
          this.loadmore();
        }
      }
    }, 200));
  },
  methods: {
    getPageData() {
      const currentPage = this.currentPage;
      const perPage = this.perPage;
      this.postsList = this.postsList.concat(this.$sortPostsByDate.slice((currentPage - 1) * perPage, currentPage * perPage));
    },
    loadmore() {
      this.currentPage = this.currentPage + 1;
      this.getPageData();
    },
    getYear(index) {
      const item = this.postsList[index];
      if (!item) {
        return;
      }
      const {
        frontmatter: {
          date
        }
      } = item;
      if (date && type(date) === 'string') {
        return date.slice(0, 4);
      }
    },
    getDate(item) {
      const {
        frontmatter: {
          date
        }
      } = item;
      if (date && type(date) === 'string') {
        return date.slice(5, 10);
      }
    }
  }
};